import * as React from "react";
const SvgFolder = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 4H2v16h20V6H12l-2-2z",
  fill: "currentColor"
}));
export default SvgFolder;